import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import moment from 'moment';
import { ComponentBase } from '../component.base';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

export const MY_FORMATS = {
    parse: {
        dateInput: 'MM/YYYY',
    },
    display: {
        dateInput: 'D MMMM YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    selector: 't4-periodPicker',
    templateUrl: './periodPicker.html',
    styleUrls: ['./periodPicker.css'],
    exportAs: "T4PeriodPicker",
    providers: [
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
})
export class PeriodPicker implements OnInit {
    @Input("period") public period: moment.unitOfTime.Base = "month";
    @Input("from") public from: moment.Moment = moment().startOf(this.period);
    @Input("to") public to: moment.Moment = moment().endOf(this.period);

    @Output("fromChanged") public fromChanged = new EventEmitter<moment.Moment>();
    @Output("toChanged") public toChanged = new EventEmitter<moment.Moment>();
    @Output() public periodChanged = new EventEmitter();


    public txtFromDate = new FormControl(this.from);
    public txtToDate = new FormControl(this.to);

    selectFrom(normlized: moment.Moment, datepicker: MatDatepicker<moment.Moment>) {
        this.from.startOf(this.period);
        this.from.year(normlized.year());
        this.from.month(normlized.month());
        this.from.date(normlized.date());

        this.txtFromDate.setValue(this.from);
        //this.fromChanged.emit(this.from);
        //this.periodChanged.emit();

        datepicker.close();
    }

    selectTo(normlized: moment.Moment, datepicker: MatDatepicker<moment.Moment>) {
        this.to.startOf(this.period);
        this.to.year(normlized.year());
        this.to.month(normlized.month());
        this.to.date(normlized.date());
        this.to.endOf(this.period);

        this.txtToDate.setValue(this.to);
        //this.toChanged.emit(this.to);
        //this.periodChanged.emit();

        datepicker.close();
    }

    public selectFromYear(normalized: moment.Moment, datepicker: MatDatepicker<moment.Moment>) { if (this.period == 'year') this.selectFrom(normalized, datepicker); }
    public selectFromMonth(normalized: moment.Moment, datepicker: MatDatepicker<moment.Moment>) { if (this.period == 'month') this.selectFrom(normalized, datepicker); }
    public selectFromDate(normalized: MatDatepickerInputEvent<moment.Moment>, datepicker: MatDatepicker<moment.Moment>) { if (this.period == 'day') this.selectFrom(normalized.value, datepicker); }

    public selectToYear(normalized: moment.Moment, datepicker: MatDatepicker<moment.Moment>) { if (this.period == 'year') this.selectTo(normalized, datepicker); }
    public selectToMonth(normalized: moment.Moment, datepicker: MatDatepicker<moment.Moment>) { if (this.period == 'month') this.selectTo(normalized, datepicker); }
    public selectToDate(normalized: MatDatepickerInputEvent<moment.Moment>, datepicker: MatDatepicker<moment.Moment>) { if (this.period == 'day') this.selectTo(normalized.value, datepicker); }

    
    ngOnInit(): void {
        this.from.startOf(this.period);
        this.to.endOf(this.period);

        this.txtFromDate.setValue(this.from);
        this.txtToDate.setValue(this.to);
    }

  public next() {
    var diff = this.to.diff(this.from, this.period) + 1;
    this.from.add(diff, this.period);
    this.to.add(diff, this.period).endOf(this.period);

        this.txtFromDate.setValue(this.from);
        this.txtToDate.setValue(this.to);

        this.fromChanged.emit(this.from);
        this.toChanged.emit(this.to);
        this.periodChanged.emit();
    }

    public previous() {
      var diff = this.to.diff(this.from, this.period) + 1;
      this.from.add(0 - diff, this.period);
      this.to.add(0 - diff, this.period).endOf(this.period);

        this.txtFromDate.setValue(this.from);
        this.txtToDate.setValue(this.to);

        this.fromChanged.emit(this.from);
        this.toChanged.emit(this.to);
        this.periodChanged.emit();
  }

  public update() {
    this.fromChanged.emit(this.from);
    this.toChanged.emit(this.to);
    this.periodChanged.emit();
  }
}
